import type {ExtensionAPI} from '@wix/document-manager-core'
import {ReportableError} from '@wix/document-manager-utils'
import type {Branch} from '@wix/ambassador-editor-branches-v1-branch/types'
import type {DocumentServicesModelExtApi} from '@wix/document-manager-extensions/src/types'
import type {BranchExtensionAPI} from '@wix/document-manager-extensions/src/extensions/branches'

const MAIN_BRANCH = '00000000-0000-0000-0000-000000000000'

export const shouldAvoidRevokingBasedOnBranches = async (
    extensionAPI: ExtensionAPI
): Promise<(name: string) => boolean> => {
    try {
        const branches: Branch[] = await (extensionAPI as BranchExtensionAPI).branches.getUserAndMobileBranches()
        // In case there is no branchId we are on the main branch (MAIN_BRANCH)
        const currentBranchId = (extensionAPI as DocumentServicesModelExtApi).siteAPI.getBranchId() || MAIN_BRANCH
        const branchesAppsStatePromises = branches
            .filter(branch => branch.id !== currentBranchId)
            .map(async (branch: Branch) => {
                const appsState = await (extensionAPI as BranchExtensionAPI).branches.getBranchAppsState(branch.id)
                return {appsState, branchId: branch.id}
            })

        const branchesAppsState = (await Promise.all(branchesAppsStatePromises)).reduce(
            (acc: Record<string, any>, branchAppsState) => {
                Object.keys(branchAppsState.appsState).forEach(key => {
                    const {status} = branchAppsState.appsState[key]
                    if (status === 'INSTALLED') {
                        acc[key] = true
                    }
                })
                return acc
            },
            {}
        )
        return (appId: string) => {
            return branchesAppsState[appId] || false
        }
    } catch (error) {
        throw new ReportableError({
            errorType: 'FAILED_TO_FETCH_BRANCHES_DATA',
            message: 'Failed to fetch branches data',
            extras: {
                reason: JSON.stringify(error)
            }
        })
    }
}

export default {
    shouldAvoidRevokingBasedOnBranches
}
